import request from '@/utils/request';

//获取用户信息
export function userInfo(params) {
    return request({
        method: 'get',
        url: 'user/info',
		params
    })
}

//获取账户设置
export function getAccountSetting(params) {
    return request({
        method: 'get',
        url: 'user/getAccountSetting',
		params
    })
}
export function getInviteList(params) {
    return request({
        method: 'get',
        url: 'user/getInviteList',
		params
    })
}

//绑定手机号
export function userBindMobileForCenter(data) {
    return request({
        method: 'post',
        url: 'user/bindMobileForCenter',
		data:data
    })
}

//绑定手机号,发送验证码
export function smsSendV2(data) {
    return request({
        method: 'post',
        url: 'sms/sendV2',
		data:data
    })
}


//点数记录
export function userGetAiDropList(params) {
    return request({
        method: 'get',
        url: 'user/getAiDropList',
		params
    })
}

//文字创作历史
export function articleGetUserCenterList(params) {
    return request({
        method: 'get',
        url: 'article/getUserCenterList',
		params
    })
}

//视频创作历史
export function videoGetUserCenterList(params) {
    return request({
        method: 'get',
        url: 'video/getUserCenterList',
		params
    })
}

//会员充值配置
export function configRecharge(params) {
    return request({
        method: 'get',
        url: 'config/recharge',
		params
    })
}

//获取会员配置列表
export function configVip(params) {
    return request({
        method: 'get',
        url: 'config/vip',
		params
    })
}
// 兑换
export function exchange(data) {
	return request({
	    method: 'post',
	    url: 'order/exchange',
		data:data
	})
}
//获取订单列表
export function orderGetList(params){
    return request({
        method: 'get',
        url: 'order/getList',
		params
    })
}

//创建订单
export function orderCreate(data){
    return request({
        method: 'post',
        url: 'order/create',
		data:data
    })
}

//支付
export function payPay(data){
    return request({
        method: 'post',
        url: 'pay/pay',
		data:data
    })
}

//查询订单
export function orderQuery(data){
    return request({
        method: 'post',
        url: 'order/query',
		data:data
    })
}

//解绑微信
export function userUnbindWechat(data){
    return request({
        method: 'post',
        url: 'user/unbindWechat',
		data:data
    })
}

//意见反馈-配置
export function feedbackConfig(params){
    return request({
        method: 'get',
        url: 'feedback/config',
		params
    })
}

//意见反馈-提交
export function feedbackSubmit(data){
    return request({
        method: 'post',
        url: 'feedback/submit',
		data:data
    })
}
